import React from "react";
import moment from "moment-timezone";

export default function TimeFormat({ time, type }) {

  if (!time) return <>-</>;

  // detect user timezone
  const userTZ = moment.tz.guess();

  // convert time to user timezone
  const m = moment(time).tz(userTZ);

  let formattedTime = "";

  if (type === 1) {

    formattedTime = m.format("DD/MM/YYYY z");

  }
  else if (type === 2) {

    formattedTime = m.format("hh:mm A z");

  } else if (type === 3) {
    formattedTime = m.format('MMM DD');      // 03:30 PM IST
  }
  else if (type === 4) {
    formattedTime = m.format('MMM DD YYYY');
  }
  else {

    formattedTime = m.format("DD/MM/YYYY hh:mm A z");

  }

  return <>{formattedTime}</>;
}